import { Component } from '@angular/core';
import {ScoreService} from '../../services/score.service';
import {Router} from '@angular/router';
import {NotificationService} from '../../services/notification.service';
import {ConfirmDialogComponent} from '../../components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'tech-core-quiz-configuration',
  standalone: false,
  templateUrl: './configuration.component.html',
  styleUrl: './configuration.component.scss'
})
export class ConfigurationComponent {

  constructor(
    private scoreService: ScoreService,
    private router: Router,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {}

  resetScores() {
    this.openConfirmDialog()
  }

  navigateToQuestionConfig() {
    this.router.navigate(['/question-config']);
  }

  navigateToScoreConfig() {
    this.router.navigate(['/score-config']);
  }

  navigateToMiscSettings() {
    this.router.navigate(['/misc-settings']);
  }

  openConfirmDialog() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      width: '300px',
      height: '180px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((response) => {
      switch (response.status) {
        case "ok":
          this.scoreService.resetScores().subscribe({
            next: value => {
              this.notificationService.success('All Scores were reset!');
            }, error: err => {
              this.notificationService.success('Unexpected Error reseting scores!');
            }
          });
          break;
        case "closed":
          break;
      }
    });
  }
}
